<template>
    <div class="container-fluid">
        <br>
        <a @click="$router.go(-1)" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{ $t('words.cancel') }}
        </a>
        <button type="button" :disabled="loading" @click="saveData()"
            class="btn btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div :class="appLayout.tab" class="nav-tabs-custom" role="tabpanel">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist">
                <li class="active">
                    <a href="#tabFormulario" role="tab" data-toggle="tab">
                        <i class="fa fa-sitemap"></i>
                        Dados do Nivel
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade in active" id="tabFormulario">
                    <span v-html="$t('validation.field_required')"></span>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'is-invalid': errors.has('name')}">
                                <required /> <label>{{ $t('attributes.name') }}</label>
                                <input name="name" :placeholder="$t('words.type_name')"
                                    v-validate="{required: true, max:60}" v-model="nivel.nivel_nome" required
                                    type="text" class="form-control">
                                <div class="invalid-feedback help-block error">{{errors.first('name')}}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'is-invalid': errors.has('NivelPai')}">
                                <label>Nível Pai</label>
                                <select name="NivelPai" v-validate="{required: false}" v-model="nivel.fk_nivel_id"
                                    class="form-control">
                                    <option :value="null">{{$t('words.select')}}</option>
                                    <option v-show="item.nivel_numero <= nivel.nivel_numero || nivel.nivel_numero == -1" v-for="(item, i) in niveis" :key="i" :value="item.id">{{item.nivel_nome}}</option>
                                </select>
                                <div class="invalid-feedback help-block error">{{errors.first('NivelPai')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'is-invalid': errors.has('Ambiente')}">
                                <required /> <label>Ambiente</label>
                                <select name="Ambiente" v-validate="{required: true}" v-model="nivel.nivel_ambiente"
                                    type="text" class="form-control">
                                    <option :value="null">{{$t('words.select')}}</option>
                                    <option :value="1">0 - Comercial</option>
                                    <option :value="0">1 - Administrativo</option>
                                </select>
                                <div class="invalid-feedback help-block error">{{errors.first('Ambiente')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                nivel: {
                    nivel_nome: null,
                    nivel_ambiente: 1,
                    nivel_numero: -1,
                    fk_nivel_id: null,
                }
            }
        },
        mounted() {
            this.$store.dispatch('getAllNiveis')
            if (this.$route.name !== 'nivelCreate') {
                this.getNivelById();
            }
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        computed: {
            niveis() {
                return this.$store.state.nivel.select;
            }
        },
        methods: {
            saveData() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name == 'nivelCreate' ? this.store() : this.update();
                    }
                });
            },
            getNivelById() {
                this.$store
                    .dispatch('getNivelById', this.$route.params.id)
                    .then(response => {
                        this.nivel = response;
                    });
            },
            store() {
                this.loading = true;
                this.$store.dispatch('storeNivel', this.nivel).then(response => {
                    this.loading = false;
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$store.dispatch('getUserData');
                });
            },
            update() {
                this.loading = true;
                this.$store.dispatch('updateNivel', this.nivel).then(response => {
                    this.loading = false;
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$router.go(-1);
                });
            }
        }
    };
</script>